import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Button,
  message,
  Divider,
  Table,
  Input,
  Tooltip,
  Select,
  Space,
  Modal,
  Typography,
} from "antd";
import {
  SearchOutlined,
  DeleteOutlined,
  SkinOutlined,
  UnorderedListOutlined,
  ProfileOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import http from "../../../services/http";
const { Text } = Typography;

// STATUS
const options_status = [
  { value: 0, label: "Aguard. pedido mínimo" },
  { value: 1, label: "Em Produção" },
  { value: 2, label: "Recebido Parcial" },
  { value: 3, label: "Recebido" },
  { value: 999, label: "Todos" },
];

const status = ["Aguard. pedido mínimo", "Em Produção", "Recebido Parcial", "Recebido"];

export const UniformesPedidos = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();

  // FILTRO STATUS
  const [filtroStatus, setFiltroStatus] = useState(0);
  const [search, setSearch] = useState("");

  // DETALHES ITEM
  const [pedido, setPedido] = useState(null);

  useEffect(() => {
    listarPedidos(filtroStatus);
  }, [filtroStatus]);

  // LISTAR
  const listarPedidos = async (filtro_status) => {
    setLoading(true);
    const api = await http("get", `v1/uniformes_pedidos/listar?status=${filtro_status}`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR
  const carregarPedido = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/uniformes_pedidos/carregar/${id}`, []);

    if (api.statusCode === 200) {
      if (api.response.data) {
        setPedido(api.response.data);
        setShowModal(true);
      }
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DELETAR
  const deletarPedido = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/uniformes_pedidos/deletar`, { id: id });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      listarPedidos(filtroStatus);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Nº",
      dataIndex: "id",
      sorter: (a, b) => a.id?.toString()?.localeCompare(b.id?.toString()),
    },
    {
      title: "Solicitante",
      dataIndex: "solicitante",
      render: (_, e) => (e?.colaborador ? e.colaborador : e?.filial),
      sorter: (a, b) =>
        (a?.colaborador ? a.colaborador : a?.filial)?.localeCompare(b?.colaborador ? b.colaborador : b?.filial),
    },
    {
      title: "Produto",
      dataIndex: "produto",
      sorter: (a, b) => a.produto?.localeCompare(b.produto),
    },
    {
      title: "Tamanho",
      dataIndex: "tamanho",
      sorter: (a, b) => a.tamanho?.localeCompare(b.tamanho),
    },
    {
      title: "QTD.",
      dataIndex: "quantidade",
      sorter: (a, b) => a.quantidade?.toString()?.localeCompare(b.quantidade?.toString()),
    },
    {
      title: "Valor",
      dataIndex: "valor_total",
      sorter: (a, b) => a.valor_total?.toString()?.localeCompare(b.valor_total?.toString()),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (_, e) => status[e.status],
      sorter: (a, b) => status[a.status]?.localeCompare(status[b.status]),
    },
    {
      title: "Ações",
      width: 80,
      render: (_, e) => (
        <Space.Compact>
          <Tooltip title="Detalhes">
            <Button loading={loading} onClick={() => carregarPedido(e.id)} icon={<UnorderedListOutlined />} />
          </Tooltip>
          {e?.status === 0 && (
            <Tooltip title="Excluir">
              <Button
                loading={loading}
                icon={<DeleteOutlined />}
                onClick={() => {
                  modal.confirm({
                    title: "Deseja deletar este registro?",
                    okText: "Sim",
                    cancelText: "Cancelar",
                    onOk() {
                      deletarPedido(e.id);
                    },
                  });
                }}
              />
            </Tooltip>
          )}
        </Space.Compact>
      ),
      dataIndex: "acoes",
    },
  ];

  // PESQUISAR
  const handleFilter = (pesquisar) => {
    let filteredData = dados?.filter(
      (val) =>
        val.colaborador?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.filial?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.id?.toString()?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.tamanho?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.valor_total?.toString()?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.produto?.toLowerCase().includes(pesquisar.toLowerCase())
    );

    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search) : [];

  // RENDER ITEM
  const RenderItem = ({ titulo, descricao }) => {
    return (
      <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12} style={{ marginBottom: 20 }}>
        <Space direction="vertical" size={0}>
          <Text type="secondary" style={{ fontSize: 14 }}>
            {titulo}
          </Text>
          <Text strong style={{ fontSize: 16 }}>
            {descricao ?? "-"}
          </Text>
        </Space>
      </Col>
    );
  };

  // FORMULÁRIO
  const modalDetalhes = () => {
    return (
      <Modal
        title={
          <Text style={{ fontSize: 20 }}>
            <SkinOutlined /> {pedido?.produto}
          </Text>
        }
        open={showModal}
        width={800}
        cancelText="Fechar"
        okButtonProps={{ style: { display: "none" } }}
        cancelButtonProps={{ loading: loading, type: "primary" }}
        onCancel={() => {
          setShowModal(false);
          setPedido(null);
        }}>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <RenderItem titulo="Solicitante" descricao={pedido?.colaborador ? pedido?.colaborador : pedido?.filial} />
          <RenderItem titulo="Quantidade" descricao={pedido?.quantidade} />
          <RenderItem titulo="Quantidade Recebida" descricao={pedido?.qtd_recebida} />
          <RenderItem titulo="Adicional Manga (CM)" descricao={pedido?.adicional_manga} />
          <RenderItem titulo="Adicional Altura (CM)" descricao={pedido?.adicional_altura} />
          <RenderItem titulo="Valor Produtos" descricao={`R$ ${pedido?.valor_produtos}`} />
          <RenderItem titulo="Valor Desconto" descricao={`R$ ${pedido?.valor_desconto}`} />
          <RenderItem titulo="Valor Total" descricao={`R$ ${pedido?.valor_total}`} />
          <RenderItem titulo="Nº Parcelas" descricao={pedido?.parcelas} />
          <RenderItem titulo="Data" descricao={pedido?.data_lancamento} />
          <RenderItem titulo="Situação" descricao={status[pedido?.status]} />
        </Row>
      </Modal>
    );
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalDetalhes()}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Uniformes" onClickBack={() => navigate("/")} />
            <HeaderTitle
              title="Uniformes Pedidos"
              subtitle="Meus Pedidos"
              icon={<ProfileOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space wrap>
                <Input
                  size="middle"
                  maxLength={100}
                  prefix={<SearchOutlined />}
                  className="input"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Pesquisar..."
                  allowClear
                />
                <Select
                  style={{ minWidth: 180 }}
                  value={filtroStatus}
                  onChange={(e) => setFiltroStatus(e)}
                  options={options_status}
                />
                <Button
                  type="primary"
                  icon={<SkinOutlined />}
                  onClick={() => navigate("/uniformes/produtos")}
                  loading={loading}>
                  Ver Produtos
                </Button>
              </Space>

              <Divider />

              <Table
                rowKey="id"
                loading={loading}
                scroll={{ x: 700 }}
                columns={columns}
                dataSource={dadosFilter}
                size="small"
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
